import { el, clear } from "../dom.js";

/**
 * Email capture stays behind this feature flag until the data-retention
 * policy (BLOCKED, see Inner_Map_Especificacion_reconciliada_v2 §10) is
 * approved. Flip to `true` only once that's resolved — do not wire a real
 * input in the meantime.
 */
const EMAIL_CAPTURE_ENABLED = false;

export function renderSave(container: HTMLElement, onFinish: () => void): void {
  clear(container);
  const screen = el("section", { className: "screen" }, [
    el("span", { className: "eyebrow" }, ["Save (optional)"]),
    el("h1", {}, ["11 · Save your map."]),
    el("p", {}, [
      "You have already seen the full result. Saving it by email and switching on a 48-72 hour check-in is optional — it was never a requirement for getting this far.",
    ]),
    EMAIL_CAPTURE_ENABLED
      ? el("p", {}, ["[real form pending the data policy]"])
      : el("p", { className: "safety-note" }, [
          "This is switched off while we settle what gets stored, for how long, and with what consent.",
        ]),
    el("button", { className: "btn", type: "button" }, ["Finish"]),
  ]);
  screen.querySelector("button")!.addEventListener("click", onFinish);
  container.append(screen);
}
